module.exports = __webpack_public_path__ + "static/media/yhjt.f641ecfe.png";